import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Card, Typography } from '@material-ui/core';
import clsx from 'clsx';
import pesoChileno from '../../../utils/moneyFormat';
import useStyles from './styles';

function InfoCard({ data, card }) {
  const classes = useStyles();
  const [title, setTitle] = useState('');
  const [amount, setAmount] = useState(0);

  useEffect(() => {
    if (Object.keys(data).length !== 0) {
      if (card === 0) {
        setTitle('Total Facturado');
        setAmount(data['Total Facturado Periodo De Tiempo']);
      }
      if (card === 1) {
        setTitle('Total Servicios');
        setAmount(data['Total Servicios Periodo De Tiempo']);
      }
      if (card === 2) {
        setTitle('Total Ingreso');
        setAmount(data['Total Ingreso Periodo De Tiempo']);
      }
    }
  }, [data]);

  if (Object.keys(data).length === 0) {
    return null;
  }

  return (
    <div>
      <Card className={clsx(classes.infoCard)}>
        <Typography className={classes.infoCardtitle}>{title}</Typography>
        <Typography
          className={clsx(classes.infoCardNumber, {
            [classes.blue]: card === 0,
            [classes.grey]: card === 1,
            [classes.green]: card === 2,
          })}
        >{`${pesoChileno(amount)}`}</Typography>
      </Card>
    </div>
  );
}

InfoCard.propTypes = {
  data: PropTypes.object,
  card: PropTypes.number.isRequired,
};

export default InfoCard;
